import React from 'react';

import { InfoMessage } from '@eika/attention-message';
import { IconTypes } from '@eika/icon';
import { Link, LinkType } from '@eika/link';

import { FormTypeFeedback } from '../../actions';
import { DispatchWithState, StringKeyValue } from '../../actions/types';
import FeedbackForm from '../../components/Feedback/FeedbackForm';
import ProductImage from '../../components/ProductImage/ProductImage';
import { CompletionReducer } from '../../reducers/completion';
import { LoaderReducer } from '../../reducers/loader';

interface Props {
    action: {
        sendFeedback: (form: FormTypeFeedback) => DispatchWithState;
    };
    completion: CompletionReducer;
    loader: LoaderReducer;
    text: StringKeyValue;
}

const Control = ({ completion, action, loader, text }: Props): JSX.Element => {
    const { applicationId } = completion.ongoing;
    const {
        receiptControlTitle,
        receiptControlP1,
        receiptControlP2,
        receiptControlP3,
        receiptControlInfoBox,
        receiptControlButtonLink,
        receiptControlButtonText,
    } = text;

    return (
        <>
            {receiptControlTitle && (
                <ProductImage className="receipt__header" image="Heart" title={receiptControlTitle} />
            )}

            <div className="receipt__content">
                {receiptControlP1 && applicationId && (
                    <p>
                        <strong>{receiptControlP1}</strong> {applicationId}
                    </p>
                )}
                {receiptControlP2 && <p>{receiptControlP2}</p>}
                {receiptControlP3 && <p>{receiptControlP3}</p>}
            </div>

            {receiptControlInfoBox && (
                <InfoMessage className="receipt__info" text={receiptControlInfoBox} icon={IconTypes.LYSPAERE_24} />
            )}

            <div className="receipt__cta">
                <Link href={receiptControlButtonLink} linkType={LinkType.BUTTON_STANDARD_POSITIVE}>
                    {receiptControlButtonText}
                </Link>
            </div>

            <FeedbackForm sendFeedback={action.sendFeedback} loader={loader} text={text} />
        </>
    );
};
export default Control;
